export default "__VITE_ASSET__BhFnj1pr__"